import {Component, Input} from "@angular/core";
import {SearchController} from "../../helpers/search-controller";


@Component({
    selector: "nv-collection-search",
    templateUrl: "./nv-collection-search.component.html"
})


export class NvCollectionSearchComponent {
    @Input() controller: SearchController;
}


// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-collection/nv-collection-search.component.ts